import React, { Fragment, useCallback, useEffect, useState } from 'react';

import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

import { Radar } from 'react-chartjs-2';




// import 'gantt-task-react/dist/index.css';




import './SalesTimeline.scss';




ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);




const getNotAnswered = (riskId: string, salesProcess?: any): number => {

  let value = 0;

  if (salesProcess && salesProcess.state['risk'] && salesProcess.state['risk'].questions) {

    const questions = salesProcess.state['risk'].questions.filter((q) => q.block.id === riskId);

    questions.forEach((question) => {

      const answered = question.answers.find((a) => a.selected);

      if (answered) {
      } else {
        value += 1;
      }

    });
  }

  return value;
};




const getRiskScores = (riskId: string, salesProcess?: any): number => {

  let value = 0;

  if (salesProcess && salesProcess.state['risk'] && salesProcess.state['risk'].questions) {

    const questions = salesProcess.state['risk'].questions.filter((q) => q.block.id === riskId);

    questions.forEach((question) => {

      question.answers.forEach((answer) => {
        if (answer.selected) {
          if (answer.id === '3') {
            value += 10;
          } else if (answer.id === '2') {
            value += 2.9;
          } else if (answer.id === '1') {
            value += 1.4;
          } else {
            value += 0.0;
          }
        }
      });

    });
  }

  return value;
};




type WsSalesTimelineProps = {
  salesProcess?: any;
  title: string;
};

const WsSalesRiskRadar = ({ salesProcess, title }: WsSalesTimelineProps) => {

  const notAnswered: { [key:string]: number } = {
    '1': getNotAnswered('1', salesProcess),
    '2': getNotAnswered('2', salesProcess),
    '3': getNotAnswered('3', salesProcess),
    '4': getNotAnswered('4', salesProcess),
    '5': getNotAnswered('5', salesProcess),
    '6': getNotAnswered('6', salesProcess),
    '7': getNotAnswered('7', salesProcess),
  };

  const totalNotAnswered = notAnswered['1'] + notAnswered['2'] + notAnswered['3'] + notAnswered['4'] + notAnswered['5'] + notAnswered['6'] + notAnswered['7'];

  const scores: { [key:string]: number } = {
    '1': getRiskScores('1', salesProcess),
    '2': getRiskScores('2', salesProcess),
    '3': getRiskScores('3', salesProcess),
    '4': getRiskScores('4', salesProcess),
    '5': getRiskScores('5', salesProcess),
    '6': getRiskScores('6', salesProcess),
    '7': getRiskScores('7', salesProcess),
  };

  const overallScore = ((scores['1'] + scores['2'] + scores['3'] + scores['4'] + scores['5'] + scores['6'] + scores['7']) / 7).toFixed(2);
  
  const data = {
    labels: [
      'Client Expectations',
      [ 'Alignment - Client', 'Expectations and Contract' ],
      [ 'Contract and Deal', 'Structure' ],
      'Alignment Contract & Solution',
      'Solution Plan and Cost',
      [ 'Alignment - Solution', 'Plan and Capability' ],
      'Capability'
    ],
    datasets: [
      {
        label: 'Risk Score',
        data: [
          Number(scores['1'].toFixed(2)),
          Number(scores['2'].toFixed(2)),
          Number(scores['3'].toFixed(2)),
          Number(scores['4'].toFixed(2)),
          Number(scores['5'].toFixed(2)),
          Number(scores['6'].toFixed(2)),
          Number(scores['7'].toFixed(2)),
        ],
        backgroundColor: 'rgba(255, 99, 132, 0.1)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      },
      {
        label: 'Overall Risk',
        data: [ 1, 1, 1, 1, 1, 1, 1 ],
        backgroundColor: 'rgba(255, 166, 99, 0.2)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      },
    ],
  };


  return (
    <div className="ws-sales-solution-risk-panel" style={{ width: '100%', height: '570px' }}>

      <div style={{ width: 'calc(100% - 650px)', float: 'left' }}>
        <table className="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Risk Block</th>
              <th>Risk Score</th>
              <th>Not Answered</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Client Expectations</td>
              <td>{scores['1'].toFixed(2)}</td>
              <td>{notAnswered['1']}</td>
            </tr>
            <tr>
              <td>Alignment - Client Expectations and Contract</td>
              <td>{scores['2'].toFixed(2)}</td>
              <td>{notAnswered['2']}</td>
            </tr>
            <tr>
              <td>Contract and Deal Structure</td>
              <td>{scores['3'].toFixed(2)}</td>
              <td>{notAnswered['3']}</td>
            </tr>
            <tr>
              <td>Alignment Contract & Solution</td>
              <td>{scores['4'].toFixed(2)}</td>
              <td>{notAnswered['4']}</td>
            </tr>
            <tr>
              <td>Solution Plan and Cost</td>
              <td>{scores['5'].toFixed(2)}</td>
              <td>{notAnswered['5']}</td>
            </tr>
            <tr>
              <td>Alignment - Solution Plan and Capability</td>
              <td>{scores['6'].toFixed(2)}</td>
              <td>{notAnswered['6']}</td>
            </tr>
            <tr>
              <td>Capability</td>
              <td>{scores['7'].toFixed(2)}</td>
              <td>{notAnswered['7']}</td>
            </tr>
            <tr>
              <td>Overall Risk Score</td>
              <td>{overallScore}</td>
              <td>{totalNotAnswered}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="ws-sales-solution-timeline" style={{ width: '610px', height: '610px', marginTop: '-50px', float: 'right' }}>

        <Radar
          data={data}
          options={{

            scales: {
              r: {
                pointLabels: {
                  font: {
                    size: 14,
                    weight: 'bold'
                  },
                },
                ticks: {
                  font: {
                    size: 14,
                    weight: 'bold'
                  }
                }
              }
            },

            elements: {
              line: {
                borderWidth: 3
              }
            },

            plugins: {
              legend: {
                display: false,

                position: 'bottom', // or 'left', 'right', 'bottom'
                // align: 'center',
                
                labels: {
                  // color: 'red',
                  font: {
                    size: 14,
                    weight: 'bold'
                  },
                  padding: 10
                },
              }
            }
          }}
        />

      </div>

      <br />
    </div>
  );
};




export {
  WsSalesRiskRadar
};
